

class Bar {
  constructor(objectToFollow, color, offset) {
    this.objectToFollow = objectToFollow
    this.color = color || '#ff0099'
    this.offset = offset ? {
      x: offset.x,
      y:offset.y
    } : {
      x:0, y:0
    }
    this.x = objectToFollow.x
    this.y = objectToFollow.y
    this.value = 1
    this.maxWidth = 50
  }

  draw(c) {

    if(this.value === 1) {
      return
    }

    const height = 3
    c.beginPath()
    c.fillStyle = '#333333'
    c.rect(this.x, this.y-30, this.maxWidth, height)
    c.fill()
    c.closePath()

    c.beginPath()
    c.fillStyle = this.color
    c.rect(this.x, this.y-30, this.maxWidth*this.value, height)
    c.fill()
    c.closePath()
  }

  update(c, value) {
    this.x = this.objectToFollow.x + this.offset.x
    this.y = this.objectToFollow.y + this.offset.y
    this.value = value

    this.draw(c)
  }
}
export default Bar
